<div #appContent [class.menu-extended]="menuExtended()">
  <app-menu
    #menuComponent
    role="navigation"
    class="app-menu"
    [appPages]="appPages()"
    [activeIndex]="activeMenuItemIndex()"
    [supportSectionRefPages]="supportSectionRefPages()"
    (expansionChanged)="onExpansionChanged()"
    (menuStateChanged)="onMenuStateChanged($event)"
  >
  </app-menu>

  <div class="layout">
    <header class="header">
      <div class="header-title">
        @if (shouldShowPageTitle()) {
          <span class="title-text">{{ activeTabTitleLabelPath() || activePageTitleLabelPath() | labelsProvider }}</span>
        }
        @if (shouldShowPreviewBadge()) {
          <div class="preview-label">
            <img src="assets/images/notifications/new.svg" class="preview-img" alt="preview" />
            <div>PREVIEW</div>
          </div>
        }
        @if (titleIconPath()) {
          <img class="title-icon" [src]="titleIconPath()" />
        }
      </div>

      <div class="header-actions">
        <a class="help-container" [href]="baseUrl + '/app/support'" target="_blank">
          <img
            matTooltip="Support"
            matTooltipClass="tooltip-container"
            matTooltipPosition="below"
            src="assets/images/common/help.svg"
            alt="support"
          />
        </a>
        <app-user></app-user>
      </div>
    </header>
    <main class="content">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>

<app-side-panel #sidePanel [appContent]="appContent" role="complementary"> </app-side-panel>
